import Chip from '@mui/material/Chip'
import Autocomplete from '@mui/material/Autocomplete'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import { Grid, IconButton, InputAdornment } from '@mui/material'
import { CSSProperties, useEffect, useRef, useState } from 'react'

export default function CustomizedSearch(props: {
	isDisable?: boolean
	value: (string | never[])[]
	sx?: CSSProperties
	handleOnSearch: (selectedValue: (string | never[])[]) => void
	handleInputSearch: any
	setInputValueSearched:any
	inputValueSearched: string
}) {
	const { value, sx, handleOnSearch, handleInputSearch, setInputValueSearched, inputValueSearched } = props

	return (
		<Grid
			container
			alignItems={'center'}
			sx={
				sx ?? {
					width: '30%',
					padding: '8px',
				}
			}
		>
			<Grid item xs={12}>
				<Autocomplete
					id="search-autocomplete"
					defaultValue={[]}
					value={value}
					multiple
					options={[]}
					freeSolo
					disabled={props.isDisable}
					onChange={(event, newValue = []) => {
						handleOnSearch(newValue)
					}}
					renderTags={(value, getTagProps) =>
						value.map((option, index) => (
							<Chip variant="outlined" label={option} {...getTagProps({ index })} />
						))
					}
					renderInput={({ InputLabelProps, ...params }) => (
						<TextField
							{...params}
							InputLabelProps={InputLabelProps as TextFieldProps['InputLabelProps']}
							variant="standard"
							placeholder="Please Input User Role"
							InputProps={{
								startAdornment: <InputAdornment position="start" onClick={()=>handleInputSearch(inputValueSearched)}><SearchIcon color="info" fontSize={"large"} sx={{cursor: "pointer"}}/></InputAdornment>,
								disableUnderline: true
							}}
							onChange={(e)=>{setInputValueSearched(e.target.value)}}
							onKeyDown={(e)=> {
								if(e.key === 'Enter') {
									e.stopPropagation()
									handleInputSearch(inputValueSearched)
								}
							}}
						/>
					)}
				/>
			</Grid>
		</Grid>
	)
}
